import React from 'react';

export const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8 11C20.8 16.4124 16.4124 20.8 11 20.8C5.58761 20.8 1.2 16.4124 1.2 11C1.2 5.58761 5.58761 1.2 11 1.2C16.4124 1.2 20.8 5.58761 20.8 11ZM22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM11 4.73957C11.3314 4.73957 11.6 5.0082 11.6 5.33957V10.3999H16.6604C16.9917 10.3999 17.2604 10.6686 17.2604 10.9999C17.2604 11.3313 16.9917 11.5999 16.6604 11.5999H11.6V16.6603C11.6 16.9917 11.3314 17.2603 11 17.2603C10.6686 17.2603 10.4 16.9917 10.4 16.6603V11.5999H5.33962C5.00825 11.5999 4.73962 11.3313 4.73962 10.9999C4.73962 10.6686 5.00825 10.3999 5.33962 10.3999H10.4V5.33957C10.4 5.0082 10.6686 4.73957 11 4.73957Z"
        fill="#4951EF"
      />
    </svg>
  );
};
